// Новая главная Контроля за тогглом (business_apps#1486, эпик #1464).

export const HOME_VARIANTS = { V1: 'v1', V2: 'v2' }

// Порог крупного парка: от этого числа устройств (домофоны и камеры, meta.total
// без фильтров) поиск встаёт сразу под действиями. Пересмотр — по метрикам
// через месяц после раскатки.
export const HOME_LARGE_FLEET_THRESHOLD = 1000

export const RECENT_LIMIT = 5
export const RECENT_PERIOD = '90d'

export const GEOGRAPHY_CACHE_TTL_MS = 10 * 60 * 1000

// Минимальная длина запроса для обращения на сервер (посимвольный набор давал
// 4–5 запросов на один поиск) и дебаунс как в useDevices.
export const SEARCH_MIN_LENGTH = 2
export const SEARCH_DEBOUNCE_MS = 500

// Правило географии (раздел 5.4): улицы под городами при 2–3 городах (до 8),
// при одном городе — до 15, дальше ссылка «все улицы».
export const CITIES_WITH_STREETS_MAX = 3
export const STREETS_PER_CITY_LIMIT = 8
export const SINGLE_CITY_STREETS_LIMIT = 15

// Полный откат: тоггл спрятан, всем рендерится старый вариант.
export const HOME_V2_ENABLED = process.env.REACT_APP_HOME_V2_ENABLED !== 'false'

// Тоггл всем — только после раскатки GIS-списка на все компании
// (REACT_APP_HOME_V2_TOGGLE_FOR_ALL=true). До этого его видят пилоты: компании,
// которым Контроль-API отдаёт home_variant_default v2, и те, кто уже выбрал v2.
// Остальные остаются на старой главной: v2-запросы ходят только в ГИС.
export const HOME_V2_TOGGLE_FOR_ALL =
  process.env.REACT_APP_HOME_V2_TOGGLE_FOR_ALL === 'true'

// Релиз-нота о новой главной: /whats-new?release=<id>, id появится после публикации.
const RELEASE_ID = process.env.REACT_APP_HOME_V2_RELEASE_ID || ''
export const WHATS_NEW_PATH = RELEASE_ID
  ? `/whats-new?release=${encodeURIComponent(RELEASE_ID)}`
  : '/whats-new'

// Стабильность — шаг 3а (#1489): чип и данные строки появятся вместе с бэкендом.
export const STABILITY_ENABLED = false

// Ключи localStorage / sessionStorage.
export const STORAGE_KEYS = {
  toggleFirstSeen: 'control_home_toggle_first_seen',
  variantViewed: 'control_home_variant_viewed',
  geography: 'control_home_geography',
  fleetSize: 'control_home_fleet_size',
}

export const FILTER_NAMES = {
  MODEL: 'model',
  FIRMWARE: 'firmware_status',
  DYNAMIC_KEYS: 'dynamic_keys_state',
  STABILITY: 'stability_zone',
  INSTALLED_SINCE: 'installed_since',
}

// Модели — по семейству платы (5.x Один, 6.x IO, 7.x GOS) плюс программные
// надстройки «22» и «PRO» (model_addon). Названия моделей не переводятся.
export const MODEL_OPTIONS = [
  { key: 'one', family: 'one', label: 'Один' },
  { key: 'io', family: 'io', label: 'IO' },
  { key: 'io_22', family: 'io', addon: '22', label: 'IO 22', nested: true },
  { key: 'io_pro', family: 'io', addon: 'pro', label: 'IO PRO', nested: true },
  { key: 'gos', family: 'gos', label: 'GOS' },
  { key: 'gos_22', family: 'gos', addon: '22', label: 'GOS 22', nested: true },
  { key: 'beward', family: 'beward', label: 'Beward' },
  { key: 'eltex', family: 'eltex', label: 'Eltex' },
  {
    key: 'camera',
    family: 'camera',
    labelKey: 'devices:home_v2.model.cameras',
  },
  {
    key: 'unknown',
    family: 'unknown',
    labelKey: 'devices:home_v2.model.unknown',
  },
]

export const FIRMWARE_STATUSES = [
  'stable',
  'outdated',
  'beta',
  'unknown',
  'not_connected',
]

// Значения чипа «Прошивка» (без not_connected — это состояние строки, не фильтр).
export const FIRMWARE_FILTER_VALUES = ['stable', 'outdated', 'beta', 'unknown']

export const DYNAMIC_KEYS_STATES = [
  'unsupported',
  'needs_firmware',
  'available_off',
  'on',
]

export const STABILITY_ZONES = ['green', 'yellow', 'red', 'none']

export const INSTALLED_SINCE_VALUES = ['30d', '90d', '1y']

// meta.counters: unknown — статус «нет данных» (уточнение контракта 29.09).
export const COUNTER_KEYS = [
  'online',
  'offline',
  'unknown',
  'outdated',
  'uninstalled',
]
